import { Route, Routes, useLocation, useParams } from 'react-router-dom';
import { useShareholdersMeetingSuspenseQuery } from './ShareholdersMeeting.graphql';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { GqlMeetingValidatorErrors } from '../../graphql/base-types.graphql';
import { meetingLinkEdit, meetingLinkShow } from '../../components/Links';
import { useNavigate } from '../../components/Navigate';
import { useEffect } from 'react';
import { ShareholdersMeetingShowRoutes } from './ShareholdersMeetingShow';
import { ShareholdersMeetingEdit } from './ShareholdersMeetingEdit';

export const ShareholdersMeetingRoutes = () => {
  return (
    <Routes>
      <Route path=":meetingId" element={<ShareholdersMeeting />}>
        <Route path="*" element={<ShareholdersMeeting />} />
      </Route>
    </Routes>
  );
};

const meetingIsDone = (meetingErrors: GqlMeetingValidatorErrors) => {
  return (
    meetingErrors.details.completed &&
    !meetingErrors.details.hasError &&
    meetingErrors.language.completed &&
    !meetingErrors.language.hasError &&
    meetingErrors.registerAttendance.completed &&
    !meetingErrors.registerAttendance.hasError &&
    meetingErrors.postalVote.completed &&
    !meetingErrors.postalVote.hasError &&
    meetingErrors.agenda.completed &&
    !meetingErrors.agenda.hasError &&
    meetingErrors.summons.completed &&
    !meetingErrors.summons.hasError &&
    meetingErrors.votingList.completed &&
    !meetingErrors.votingList.hasError &&
    meetingErrors.participants.completed &&
    !meetingErrors.participants.hasError &&
    meetingErrors.emailSummons.completed &&
    !meetingErrors.emailSummons.hasError
  );
};

const ShareholdersMeeting = () => {
  const companyId = useCompanyId();
  const { navigate } = useNavigate();
  const { meetingId } = useParams<{ meetingId: string }>();

  const {
    data: { meeting, meetingErrors },
  } = useShareholdersMeetingSuspenseQuery({ variables: { companyId, meetingId: meetingId! } });

  const { pathname } = useLocation();

  const shouldRedirect = pathname.endsWith(meeting.id);

  useEffect(() => {
    if (!shouldRedirect) {
      return;
    }
    if (meetingIsDone(meetingErrors)) {
      void navigate(meetingLinkShow(meeting), undefined, { replace: true });
    } else {
      void navigate(meetingLinkEdit(meeting), undefined, { replace: true });
    }
  }, [meetingErrors, meeting, navigate, shouldRedirect]);

  if (!shouldRedirect) {
    return (
      <Routes>
        <Route path="show" element={<ShareholdersMeetingShowRoutes meetingId={meeting.id} />}>
          <Route path="*" element={<ShareholdersMeetingShowRoutes meetingId={meeting.id} />} />
        </Route>
        <Route path="edit" element={<ShareholdersMeetingEdit meetingId={meeting.id} />}>
          <Route path="*" element={<ShareholdersMeetingEdit meetingId={meeting.id} />} />
        </Route>
      </Routes>
    );
  }
  return '';
};
